<template>
  <div class="container">
    <div
      class="pageloader has-text-centered"
      v-bind:class="{ 'is-active': this.isLoadingList }"
    >
      <span class="title">{{ $t("loading.patienter") }}</span>
    </div>
    <b-message
      id="errorMessage"
      type="is-danger"
      :active.sync="errorShow"
      :title="$t('message.error')"
    >
      <span
        v-for="(message, key) in errorMessage"
        :key="key"
        class="errorLogger"
      >
        {{ message }}
      </span>
    </b-message>
    <div style="font-size:16px; padding:10px;margin-top:5px;" class="bloc">
      {{ title }}
    </div>

    <!-- Table listing the attendees -->
    <div class="bloc" style="padding:14px">
      <div style="margin-bottom: 20px;font-size:12px;">
        {{ $t("attendees.listing") }}
      </div>
      <div>
        <div style="display:flex; flex-wrap:wrap; width:100%;">
          <button
            style="margin:10px 5px 10px 0px;"
            @click="enableCreate"
            class="button is-primary"
          >
            {{ $t("attendees.adding") }}
          </button>
          <div style="margin:10px 5px 10px 0px;" class="panel_number">
            {{
              $tc("attendees.nombre_inscrit", backupData.length, {
                nbAttendees: backupData.length
              })
            }}
          </div>
          <div style="margin:10px 5px 10px 0px;" class="panel_number">
            {{
              $tc("attendees.nombre_present", this.getPresentTotal, {
                nbAttendees: this.getPresentTotal
              })
            }}
          </div>
          <div style="margin:10px 5px 10px auto;">
            <b-field>
              <b-input
                :placeholder="$t('attendees.searchAttendee')"
                @input="search"
                v-model="search_query_attendees"
              ></b-input>
              <p class="control">
                <button class="button" @click="search">
                  {{ $t("button.chercher") }}
                </button>
              </p>
            </b-field>
          </div>
        </div>

        <div class="is-clearfix"></div>
      </div>
      <b-table
        :data="data"
        :narrowed="true"
        :hoverable="true"
        id="tableAttendees"
        :paginated="data.length > 50 ? true : false"
        per-page="50"
        default-sort="last_name"
        pagination-position="both"
      >
        <template>
          <b-table-column
            v-slot="props"
            custom-key="lastName"
            field="last_name"
            sortable
            centered
            :label="$t('attendees.lastName')"
          >
            <b-input
              v-if="props.row.editable"
              type="text"
              v-model="props.row.last_name"
              :placeholder="props.row.last_name"
            >
            </b-input>
            <p v-else>
              {{ props.row.last_name }}
            </p>
          </b-table-column>
          <b-table-column
            v-slot="props"
            custom-key="firstName"
            field="first_name"
            sortable
            centered
            :label="$t('attendees.firstName')"
          >
            <b-input
              v-if="props.row.editable"
              type="text"
              v-model="props.row.first_name"
              :placeholder="props.row.first_name"
            >
            </b-input>
            <p v-else>
              {{ props.row.first_name }}
            </p>
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="email"
            field="email"
            sortable
            centered
            :label="$t('attendees.email')"
          >
            <b-input
              v-if="props.row.editable"
              type="text"
              v-model="props.row.email"
              :placeholder="props.row.email"
            >
            </b-input>
            <p v-else v-show="props.row.email !== 'null'">
              {{ props.row.email }}
            </p>
          </b-table-column>
          <b-table-column
            v-slot="props"
            custom-key="company"
            field="company"
            sortable
            centered
            :label="$t('attendees.company')"
          >
            <p v-show="props.row.company !== 'null'">
              {{ props.row.company }}
            </p>
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="present"
            field="present"
            sortable
            centered
            :label="$t('attendees.present')"
          >
            <b-switch
              type="is-success"
              v-model="props.row.present"
              :true-value="1"
              :false-value="0"
              :native-value="!!data[props.index].present"
              v-if="props.row.editable"
            >
              {{
                props.row.present ? $t("attendees.true") : $t("attendees.false")
              }}
            </b-switch>
            <p v-else>
              <b-icon
                v-if="props.row.present"
                pack="fas"
                icon="check-circle"
                style="color:limegreen;"
              ></b-icon>
              <b-icon
                v-else
                pack="fas"
                icon="times-circle"
                style="color:red;"
              ></b-icon>
            </p>
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="agree"
            field="accepts_terms_conditions"
            sortable
            centered
            :label="$t('attendees.agrees')"
          >
            <p>
              <b-icon
                v-if="props.row.accepts_terms_conditions"
                pack="fas"
                icon="check-circle"
                style="color:limegreen;"
              ></b-icon>
              <b-icon
                v-else-if="
                  props.row.accepts_terms_conditions === 0 ||
                    props.row.accepts_terms_conditions === false
                "
                style="color:red;"
                pack="fas"
                icon="times-circle"
              ></b-icon>
              <b-icon v-else pack="fas" icon="question-circle"></b-icon>
            </p>
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="edit"
            field="edit"
            centered
            :label="$t('attendees.edit')"
          >
            <a v-if="props.row.editable" @click="sendEdit(props)">
              <b-icon pack="fas" icon="check-circle"></b-icon>
            </a>
            <a v-else @click="enableEdit(props)">
              <b-icon pack="fas" icon="user-edit"></b-icon>
            </a>
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="delete"
            field="delete"
            centered
            :label="$t('attendees.delete')"
          >
            <a @click="dialogBeforeDelete(props)">
              <b-icon pack="fas" icon="times-circle"></b-icon>
            </a>
          </b-table-column>
        </template>

        <!-- <template slot="footer">
                <b>{{$t('attendees.readTerms')}} </b> <a :href="'~@/assets/' + getPdfLanguage()" target="_blank" rel="noopener noreferrer">{{ $t('attendees.openTerms') }} </a>
            </template> -->

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon pack="far" icon="frown"> </b-icon>
              </p>
              <p>{{ $t("attendees.none") }}.</p>
            </div>
          </section>
        </template>
        <template slot="bottom-left"> </template>
      </b-table>
      <div class="createAdminContainer">
        <a @click="download()" class="button is-primary">{{
          $t("attendee.download")
        }}</a>

        <button
          v-if="data.length > 0"
          @click="deleteAll"
          class="button openDelete is-primary"
        >
          {{ $t("attendees.emptyAll") }}
        </button>
      </div>
    </div>
    <b-modal
      :width="640"
      :active.sync="editing"
      @close="
        () => {
          search_query_attendees = '';
        }
      "
      ><div id="modalEdit">
        <Edit :row="rowBeingEdited.row" />
      </div>
    </b-modal>
    <b-modal
      :width="640"
      :active.sync="creating"
      @close="
        () => {
          search_query_attendees = '';
        }
      "
      ><div id="modalEdit">
        <Create
          @errorMessage="
            message => {
              errorShow = true;
              errorMessage = message;
            }
          "
          :eventId="event_id"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Edit from "../popup/popupEditAdmin";
import Create from "../popup/popupCreateAdmin";

export default {
  name: "attendeesAdmin",
  components: {
    Edit,
    Create
  },
  data() {
    let attendeesFile = "";
    return {
      nameEvent: "",
      event_id: this.$store.state.evenement.configure_links_evenement,
      errorMessage: "",
      errorShow: false,
      title: this.$store.getters.configure_links_evenement_name,
      rowBeingEdited: "",
      editing: false,
      creating: false,
      validEmail: true,
      firstName: "",
      lastName: "",
      file: null,
      attendeesFile,
      data: [],
      backupData: [],
      isLoadingList: true,
      list: [],
      url_sso_front: process.env.URL_SSO_FRONT,
      search_query_attendees: "",
      email: "",
      fields: {
        Prénom: "first_name",
        Nom: "last_name",
        Email: "email",
        Présence: "present",
        "Accepte droits à l'image": "accepts_terms_conditions"
      }
    };
  },
  // Hookpoint left to keep the end of the loading, needs to be updated once I finish the API//
  created() {
    this.fetchData();
    let room = "Room_Eventify_" + this.event_id;
    this.$socket.emit("room", room);
  },
  beforeDestroy() {
    let room = "Room_Eventify_" + this.event_id;
    this.$socket.emit("leave_room", room);
  },
  sockets: {
    connect: function() {
      let room = "Room_Eventify_" + this.event_id;
      this.$socket.emit("room", room);
    },
    channel: function(data) {
      let message = JSON.parse(decodeURIComponent(data));
      switch (message.type) {
        case "DELETE_ATTENDEE":
          if (Array.isArray(message.attendee)) {
            this.backupData = this.data = message.attendee;
          } else {
            this.backupData = this.data = [];
          }
          this.search_query_attendees = "";
          break;

        case "NEW_ATTENDEE":
          this.backupData.push(message.attendee);
          break;

        case "UPDATE_ATTENDEE":
          let index = this.data.findIndex(x => x.id === message.attendee.id);
          if (index >= 0) {
            this.backupData[
              index
            ].first_name = message.attendee.first_name.replace(/\s/g, "");
            this.backupData[
              index
            ].last_name = message.attendee.last_name.replace(/\s/g, "");
            if (message.attendee.email) {
              this.backupData[index].email =
                message.attendee.email.replace(/\s/g, "") || "";
            } else {
              this.backupData[index].email = "";
            }
            if (message.attendee.company) {
              this.backupData[index].company =
                message.attendee.company.replace(/\s/g, "") || "";
            } else {
              this.backupData[index].company = "";
            }
            this.backupData[index].present = message.attendee.present;
            this.backupData[index].accepts_terms_conditions =
              message.attendee.accepts_terms_conditions;
            this.backupData[index].id = message.attendee.id;
            this.backupData[index].event_id = message.attendee.event_id;
            this.backupData[index].editable = message.attendee.editable;
          } else {
            this.backupData.push(message.attendee);
          }
          break;

        default:
          break;
      }
    }
  },
  methods: {
    deleteAll() {
      this.$buefy.dialog.confirm({
        message: this.$i18n.t("attendees.sure"),
        onConfirm: () => this.trueDeleteAll(),
        type: "is-danger",
        cancelText: this.$i18n.t("attendees.cancel"),
        confirmText: this.$i18n.t("attendees.confirm")
      });
    },
    trueDeleteAll() {
      let payload = {
        event_id: this.event_id
      };
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + window.store.getters.userToken;
      axios
        .delete(`${process.env.URL_SSO_API}shortcut/attendeesAll`, {
          data: payload
        })
        .then(res => {
          this.backupData = this.data = [];
        });
    },
    search(e) {
      let localeData = this.backupData;
      if (e !== "") {
        this.data = [];
        var regex = new RegExp(
          "^" + this.search_query_attendees + "[a-zA-Z0-9.,$;@ éè]*$",
          "i"
        );
        for (let i = 0; i < localeData.length; i++) {
          let row = localeData[i];

          if (
            regex.test(row.email) ||
            regex.test(row.last_name) ||
            regex.test(row.first_name)
          ) {
            this.data.push(row);
          }
        }
      } else {
        this.data = this.backupData;
      }
    },
    enableEdit(props) {
      this.rowBeingEdited = props;
      this.editing = true;
    },
    enableCreate() {
      this.creating = true;
    },
    dialogBeforeDelete(props) {
      this.$buefy.dialog.confirm({
        message: this.$i18n.t("attendees.sureSingle"),
        onConfirm: () => {
          this.handleDelete(props);
        },
        type: "is-danger",
        cancelText: this.$i18n.t("attendees.cancel"),
        confirmText: this.$i18n.t("attendees.confirm")
      });
    },
    handleDelete(props) {
      let index = this.data.findIndex(x => x.id === props.row.id);

      let payload = {
        id: this.data[index].id,
        event_id: this.$store.state.evenement.configure_links_evenement
      };
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + window.store.getters.userToken;
      axios
        .delete(`${process.env.URL_SSO_API}shortcut/attendees`, {
          data: payload
        })
        .then(res => {
          if (
            res.data !== null &&
            res.data !== undefined &&
            res.data !== [] &&
            typeof res.data !== "number"
          ) {
            res.data.forEach(attendee => {
              attendee.editable = false;
              this.backupData = this.data = res.data;
            });
          }

          this.$buefy.toast.open({
            type: "is-success",
            message: this.$i18n.t("toast.deleteSuccess")
          });
        })
        .catch(err => {
          this.$buefy.toast.open({
            type: "is-danger",
            message: this.$i18n.t("toast.uploadError" + err)
          });
        });
    },
    fetchData() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + window.store.getters.userToken;
      axios
        .get(
          `${process.env.URL_SSO_API}shortcut/attendees?id=${this.$store.state.evenement.configure_links_evenement}`
        )
        .then(response => {
          this.isLoadingList = false;
          this.data = [];

          if (response.data[response.data.length - 1].name !== undefined) {
            this.nameEvent = response.data[response.data.length - 1].name;
            this.event_id = response.data[response.data.length - 1].id;
            let room = "Room_Eventify_" + this.event_id;

            this.$socket.emit("room", room);

            for (let i = 0; i < response.data.length - 1; i++) {
              this.data.push({
                first_name: response.data[i].first_name,
                last_name: response.data[i].last_name,
                email: response.data[i].email || "",
                company: response.data[i].company || "",
                present: response.data[i].present,
                accepts_terms_conditions:
                  response.data[i].accepts_terms_conditions,
                id: response.data[i].id,
                event_id: response.data[i].event_id,
                editable: false
              });
            }
            this.backupData = this.data;
          } else {
            this.event_id = response.data[0].id;
            let room = "Room_Eventify_" + this.event_id;

            this.$socket.emit("room", room);
          }
        })
        .catch(error => {
          // window.location = process.env.URL_SSO_FRONT
        });
      this.isLoadingList = false;
    },
    handleAcceptTC(props) {
      this.sendEdit(props);
    },

    getPdfLanguage() {
      let pdf = "";
      this.$store.state.langage.langue === "fr"
        ? (pdf = "TermeEtConditions.pdf")
        : (pdf = "TermsAndConditions.pdf");
      return pdf;
    },
    getCsvLanguage() {
      let csv = "";
      this.$store.state.langage.langue === "fr"
        ? (csv = "/Gabarit.csv")
        : (csv = "/Template.csv");
      return csv;
    },
    download() {
      let csvContent =
        "data:text/csv;charset=utf-8," +
        "\uFEFF" +
        this.$i18n.t("attendees.lastName") +
        " ; " +
        this.$i18n.t("attendees.firstName") +
        " ; " +
        this.$i18n.t("attendees.email") +
        " ; " +
        this.$i18n.t("attendees.company") +
        " ; " +
        "\uFEFF" +
        this.$i18n.t("attendees.present") +
        " ; " +
        this.$i18n.t("attendees.agrees") +
        "\n";
      this.data.map(object => {
        csvContent +=
          object.last_name +
          "; " +
          object.first_name +
          "; " +
          object.email +
          " ; " +
          object.company +
          " ; ";
        csvContent += object.present
          ? this.$i18n.t("attendees.true") + " ;"
          : this.$i18n.t("attendees.false") + " ; ";
        csvContent += object.accepts_terms_conditions
          ? this.$i18n.t("attendees.true") + " "
          : this.$i18n.t("attendees.false") + "";
        csvContent += "\n";
        return true;
      });

      var encodedUri = encodeURI(csvContent);

      var downloadLink = document.createElement("a");
      downloadLink.href = encodedUri;
      downloadLink.download = "attendees.csv";

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  },
  computed: {
    ...mapGetters(["evenements_affiche"]),
    search_query: {
      get: function() {
        return this.$store.state.evenement.search_query;
      },
      set: function(newValue) {
        this.$store.commit(`UPDATE_SEARCH_QUERY_INPUT`, newValue);
      }
    },
    getPresentTotal: {
      get: function() {
        let total = 0;
        this.backupData.forEach(element => {
          if (element.present) {
            total++;
          }
        });
        return total;
      }
    }
  }
};
</script>

<style scoped>
#modalEdit {
  font-size: 12px;
  margin: 2em;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
}
.errorLogger::before {
  content: "\A";
  white-space: pre;
}
.errorLogger {
  line-break: strict;
  line-height: 10px !important;
  display: block;
  margin-left: 10px;
}
.errorLogger:not(:first-of-type):not(:last-of-type) {
  margin-left: 40px;
}

.createAdminContainer {
  margin-bottom: 80px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.createAdminContainer button,
.createAdminContainer a {
  margin: 5px 0px;
  display: block;
}

/* .openDelete {
  background-color: red;
  color: #000;
} */

#upDownButtons {
  margin-top: 25px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  justify-items: center;
  align-items: flex-end;
  flex-wrap: wrap;
  width: 70%;
}
#upDownButtonsContainer {
  width: 100%;
}

.infoText {
  font-size: 0.7em;
}

.emailInputContainer {
  height: 50%;
}

.emailInput {
  top: calc(20% + 3vh);
}

#fileUploader {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

#fileUploader + label {
  cursor: pointer; /* "hand" cursor */
}

#fileUploader:focus + label {
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}

#labelFileUploader {
  margin-right: auto;
  width: 50%;
}

.senderUpload {
  /* width: 100%; */
  margin-top: 30px;
  margin-right: 190px;
  margin-bottom: 20px;
}

#addAttendee {
  max-width: none;
  width: 100%;
}

#lastName {
  margin: 10px 0;
}

#email {
  margin: 10px 0;
}

#folderIcon {
  margin-left: 10px;
}

#tableAttendees {
  background-color: white;
  margin-bottom: 10px;
}
.b-table {
  background-color: white;
  margin-bottom: 10px;
}

.fileUploader {
  justify-content: space-evenly;
  flex-wrap: wrap;
}

#canvasDownload {
  width: 100%;
}

.upload {
  margin-top: 10px;
  width: 100%;
}

.searchBox {
  margin-bottom: 25px;
}

#inputBuefy {
  width: 100%;
}

#canvasButton {
  width: 100%;
}

.panel_number {
  border: 0.5px solid #424a60;
  font-weight: bold;
  border-radius: 10px;
  color: #424a60;
  margin-left: 10px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/attendees/AttendeesAdmin.vue